module.exports = __webpack_public_path__ + "img/yy-8-2.e2e7d1b5.svg";